// Generated by BUCKLESCRIPT VERSION 2.2.3, PLEASE EDIT WITH CARE
'use strict';

var Css = require("bs-css/lib/js/src/Css.js");
var React = require("react");
var ReasonReact = require("reason-react/lib/js/src/ReasonReact.js");

var initialBodyImg = Css.style(/* :: */[
      Css.flexDirection(Css.column),
      /* :: */[
        Css.alignItems(Css.center),
        /* :: */[
          Css.justifyContent(Css.center),
          /* :: */[
            Css.margin4(Css.px(5), Css.px(0), Css.px(15), Css.px(0)),
            /* :: */[
              Css.padding2(Css.px(0), Css.px(0)),
              /* :: */[
                Css.position(/* relative */903134412),
                /* [] */0
              ]
            ]
          ]
        ]
      ]
    ]);

function d(property, value) {
  return /* `declaration */[
          -434952966,
          /* tuple */[
            property,
            value
          ]
        ];
}

function strokeDashArray(x) {
  return d("strokeDasharray", String(x) + "px");
}

function strokeDashOffset(x) {
  return d("strokeDashoffset", String(x) + "px");
}

function circleAnimation(deg) {
  return Css.style(/* :: */[
              strokeDashArray(440),
              /* :: */[
                strokeDashOffset(deg),
                /* :: */[
                  Css.transition(/* Some */[1], /* None */0, /* Some */[/* linear */-325037595], "all"),
                  /* [] */0
                ]
              ]
            ]);
}

var roundIconBox = Css.style(/* :: */[
      Css.width(/* `percent */[
            -119887163,
            100.0
          ]),
      /* :: */[
        Css.cursor(/* pointer */-786317123),
        /* :: */[
          Css.margin4(Css.px(0), Css.px(0), Css.px(0), Css.px(0)),
          /* [] */0
        ]
      ]
    ]);

var roundIcon = Css.style(/* :: */[
      Css.margin2(Css.px(20), Css.px(0)),
      /* :: */[
        Css.width(/* `percent */[
              -119887163,
              100.0
            ]),
        /* [] */0
      ]
    ]);

var svg = Css.style(/* :: */[
      Css.transform(Css.rotate(/* `deg */[
                4995526,
                -90
              ])),
      /* [] */0
    ]);

var countNumber = Css.style(/* :: */[
      Css.fontSize(Css.px(40)),
      /* :: */[
        Css.position(/* absolute */-1013592457),
        /* :: */[
          Css.color(/* `hex */[
                5194459,
                "FF328C"
              ]),
          /* [] */0
        ]
      ]
    ]);

var Styles = /* module */[
  /* initialBodyImg */initialBodyImg,
  /* d */d,
  /* strokeDashArray */strokeDashArray,
  /* strokeDashOffset */strokeDashOffset,
  /* circleAnimation */circleAnimation,
  /* roundIconBox */roundIconBox,
  /* roundIcon */roundIcon,
  /* svg */svg,
  /* countNumber */countNumber
];

var component = ReasonReact.statelessComponent("Counter");

function make(countdownTime, _, time, fixed, _$1) {
  var i = -time;
  var res = i + countdownTime - 1.0;
  var degreesFloat = 440.0 - (res + 1.0) * (440.0 / countdownTime);
  var degrees = degreesFloat | 0;
  var newrecord = component.slice();
  newrecord[/* render */9] = (function () {
      var match = +(fixed !== /* true */1);
      return React.createElement("div", {
                  className: initialBodyImg
                }, React.createElement("svg", {
                      className: svg,
                      height: "160",
                      width: "160",
                      xmlns: "http://www.w3.org/2000/svg"
                    }, React.createElement("g", undefined, React.createElement("circle", {
                              className: circleAnimation(degrees),
                              id: "circle",
                              cx: "81",
                              cy: "81",
                              fill: "#FFF",
                              r: "69.85699",
                              stroke: "#FF328C",
                              strokeWidth: "8"
                            }))), React.createElement("div", {
                      className: countNumber
                    }, match !== 0 ? String(time) : String(countdownTime)));
    });
  return newrecord;
}

exports.Styles = Styles;
exports.component = component;
exports.make = make;
/* initialBodyImg Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/counter3.re
// module id = 124
// module chunks = 0